import $ from 'jquery';
import debug from 'bows/dist/bows.min.js';

let log = debug('analytics');

export const trackEvent = function( category, action, label ) {
	let track = ( callback ) => {
		// Debugging
		log('Track Event:', { category: category, action: action, label: label });

		if ( window.dataLayer ) { // gtm.js
			window.dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': category,
				'eventAction': action,
				'eventLabel': label
			});
		} else if ( typeof window.gtag === 'function' ) { // gtag.js
			window.gtag('event', action, {
				'event_category': category,
				'event_action': action, // Event name is default, this is redundant
				'event_label': label,
				'event_callback': () => callback( 'gtag event sent!' )
			});
		} else if ( typeof window.ga === 'function' ) { // analytics.js
			// Resolve on hitCallback
			window.ga('send', 'event', category, action, label, {
				hitCallback: () => callback( 'ga event sent!' )
			});
		} else {
			// No handler found!
			return callback( 'No analytics tracker exists!' );
		}
	}

	let trackPromise;
	if ( ! window.Promise ) {
		log('Browser does not support promises!');
		track( () => {} ); // noop
		// Create fake promise
		trackPromise = {
			then: ( callback ) => {
				// insta-resolve
				if ( typeof callback === 'function' ) {
					callback();
				}
			}
		}
	} else {
		// This promise is ALWAYS resolved to avoid unhandled promise rejection
		trackPromise = new Promise( ( resolve, reject ) => {
			track( resolve );

			// Reject if it takes more than 1s
			setTimeout( () => resolve( 'Analytics event timed out after 1s' ), 1000 );
		} );
	}

	return trackPromise;
}

/**
 * Callback handler for mousedown and click events which forwards to a URL (if needed)
 *
 * Expects e.data property containing {
 *   category*
 *   action (optional) - defaults to element href
 *   label (optional) - defaults to element text
 *   href (optional): where to forward - defaults to element href
 * }
 *
 * @param Event e
 */
export const trackAllClicks = function ( e ) {

	if(e){
		// Deep copy to avoid reference issues
		let data = JSON.parse( JSON.stringify( e.data ) );

		let handler = () => {
			// Track event
			return trackEvent( data.category, data.action, data.label ).then( ( val ) => {
				// Debugging
				log('Event message:', val);
			} );
		};

		// Set defaults
		if ( ! data.action && e.currentTarget && e.currentTarget.href ) {
			data.action = e.currentTarget.href;
		} else if ( ! data.action && e.type ) {
			data.action = e.type;
		}
		if ( ! data.label && e.currentTarget && e.currentTarget.textContent ) {
			data.label = e.currentTarget.textContent.trim();
		} else if ( ! data.label ) {
			data.label = document.title;
		}
		if ( ! data.href && e.currentTarget && e.currentTarget.href ) {
			data.href = e.currentTarget.href;
		}

		switch ( e.type ) {
			case 'click':
				if ( typeof e.isDefaultPrevented === 'function' && e.isDefaultPrevented() ) {
					log('Default prevented on click');
					handler();
				} else if ( ! data.href || data.href === '#' || data.href.replace( window.location.href, '' ).length === 0 ) {
					log('No href on click');
					handler();
				} else if ( e.currentTarget && 'javascript:' === e.currentTarget.protocol ) {
					log('JavaScript link on click');
					handler();
				} else if ( e.currentTarget && e.currentTarget.target && ! e.currentTarget.target.match( /^_(self|parent|top)$/i ) ) {
					log('Target ' + e.currentTarget.target + ' on click');
					handler();
				} else if ( e.ctrlKey || e.shiftKey || e.which == 2 ) { // e.which == 2 for jquery-triggered middle clicks
					log('Ctrl/shift/middle click');
					handler();
				} else if ( data.href && typeof e.preventDefault === 'function' ) {
					log('Delaying click', data.href);
					if( data.category !== 'download' && data.category !== 'external_link' ) {
					// Special handling
					e.preventDefault();
					// Change the window location
					handler().then( () => window.location.href = data.href );
					}
				} else {
					log('Unknown click event', e);
					handler();
				}
			break;
			case 'mousedown':
				if ( e.button === 1 ) { // Only track middle clicks
					log('Middle click');
					handler();
				}
			break;
			default:
				log('Unknown event', e.type);
				handler();
				return;
			break;
		}
	}
}

export const trackPageview = function() {
	let track = ( callback ) => {
		// Debugging
		log('Track Pageview');

		if ( typeof window.gtag === 'function' && window.gtag_id ) { // gtag.js
			window.gtag('config', window.gtag_id);
			return callback('gtag pageview sent!');
		} else if ( typeof window.ga === 'function' ) { // analytics.js
			window.ga('send', 'pageview');
			return callback('ga pageview sent!');
		} else {
			// No handler found!
			return callback('No analytics tracker exists!');
		}
	}

	let trackPromise;
	if ( ! window.Promise ) {
		log('Browser does not support promises!');
		track(() => {}); // noop
		// Create fake promise
		trackPromise = {
			then: ( callback ) => {
				// insta-resolve
				if ( typeof callback === 'function' ) {
					callback();
				}
			}
		}
	} else {
		// This promise is ALWAYS resolved to avoid unhandled promise rejection
		trackPromise = new Promise((resolve, reject) => {
			track(resolve);

			// Reject if it takes more than 1s
			setTimeout(() => resolve('Analytics event timed out after 1s'), 1000);
		});
	}

	return trackPromise;
}

export function analyticsInit() {
	let $document = $(document);
	let downloadExtensions = /\.(docx?|pptx?|xlsx?|pdf|zip|jpe?g|png|gif)(\?.*|#.*)?$/; // Regex matching download extensions (ignoring query strings/hashes)

	// chat portal clicked
	$document.on( 'click', '.chat-button, .cart__help-button, .gated-content__help-button', { category: 'chat', action: 'click' }, ( e ) => {
		e.data.label = e.currentTarget.href;
		return trackAllClicks( e );
	} );

	// // member login clicked
	// $document.on( 'click', '.member--login', { category: 'login', action: 'click' }, ( e ) => {
	// 	e.data.label = e.currentTarget.href;
	// 	return trackAllClicks( e );
	// } );

	// an external link clicked
	const comp = new RegExp(location.host);
	$('a:not(.modal__share-icon)').each(function(){
		if(comp.test($(this).attr('href')) !== true){
			$(this).on( 'click', null, { category: 'external_link', action: 'click' }, ( e ) => {
				e.data.label = e.currentTarget.href;
				return trackAllClicks( e );
			} );
		}
	 });

	// download link clicked
	$document.on( 'click', 'a[download]', { category: 'download', action: 'click' }, ( e ) => {
		return trackAllClicks( e );
	} );

	// Form input
	$document.on( 'input', 'form input, form select, form textarea', { category: 'form', action: 'input' }, ( e ) => {
		let $form = $( e.currentTarget ).closest( 'form' );
		if ( $form.length && ! $form.data( 'input' ) ) {
			trackEvent( 'form', 'input', $form[0].action );
			$form.data( 'input', true ); // Mark as input
		}
	} );

	// Form submit
	$document.on( 'submit', 'form', { category: 'form', action: 'submit' }, ( e ) => {
		trackEvent( 'form', 'submit', e.currentTarget.action );
	} );

	// Share
	$('.social-resource-list').on( 'click', '[data-modal-container]', ( e ) => {
		let title = $(e.currentTarget).data('title');
		trackEvent( 'share', 'modal', title );
	} );
	$('.modal__share--twitter').on( 'click', { category: 'share', action: 'click' }, ( e ) => {
		let title = $(e.currentTarget).closest('.modal__text').children();
		trackEvent( 'share', 'twitter', title[0].innerText );
	} );
	$('.modal__share--facebook').on( 'click', { category: 'share', action: 'click' }, ( e ) => {
		let title = $(e.currentTarget).closest('.modal__text').children();
		trackEvent( 'share', 'facebook', title[0].innerText );
	} );
	$('.modal__share--download').on( 'click', { category: 'share', action: 'click' }, ( e ) => {
		let title = $(e.currentTarget).closest('.modal__text').children();
		trackEvent( 'share', 'download', title[0].innerText );
	} );


	trackAllClicks;
	trackEvent;
	trackPageview;
}

export default {
	analyticsInit: analyticsInit,
	trackEvent: trackEvent,
	trackAllClicks: trackAllClicks,
	trackPageview: trackPageview
};
